import { Component } from '@angular/core';
import { FeedbackPlatformNotificationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Notifications') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformnotification-form',
    templateUrl: './feedbackplatformnotification.form.component.html'
})
export class FeedbackPlatformNotificationFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformNotificationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

